import { IsEntryNamePathSegment, IsRootPathSegment, IsValidPathSegment } from './segment';
import { ErrorWithCode } from '../helpers/ErrorWithCode';
export function PathSegmentsPush(path, segment, options) {
    if (IsValidPathSegment(segment)) {
        if (segment === '.') {
        }
        else if (segment === '..') {
            const lastSegment = path[path.length - 1];
            if (lastSegment === '.') {
                path[0] = segment;
            }
            else if (lastSegment === '..') {
                path.push(segment);
            }
            else if (IsRootPathSegment(lastSegment, options.rootRegExp)) {
                throw new ErrorWithCode(`Cannot push '..' into a path with only one segment of type root`, 'POP_ROOT');
            }
            else {
                path.pop();
            }
        }
        else if (IsRootPathSegment(segment, options.rootRegExp)) {
            throw new ErrorWithCode(`Cannot push a root into a path`, 'PUSH_ROOT');
        }
        else {
            path.push(segment);
        }
    }
    else {
        throw new ErrorWithCode(`Segment ${JSON.stringify(segment)} is invalid`, `INVALID_NAME`);
    }
}
export function PathSegmentsPop(path) {
    if (path.length === 1) {
        path[0] = '.';
    }
    else {
        path.pop();
    }
}
export function PathSegmentsUnshift(path, segment, options) {
    if (IsValidPathSegment(segment)) {
        const firstSegment = path[0];
        if (firstSegment === '.') {
            if (IsEntryNamePathSegment(segment, options.rootRegExp)) {
                path.splice(1, 0, segment);
            }
            else {
                path[0] = segment;
            }
        }
        else if (firstSegment === '..') {
            if (segment === '.') {
            }
            else if (segment === '..') {
                path.unshift(segment);
            }
            else if (IsRootPathSegment(segment, options.rootRegExp)) {
                throw new ErrorWithCode(`Cannot unshift a root into a path starting with '..'`, 'UNSHIFT_ROOT');
            }
            else {
                if (path.length === 1) {
                    path[0] = '.';
                }
                else {
                    path.shift();
                }
            }
        }
        else if (IsRootPathSegment(firstSegment, options.rootRegExp)) {
            throw new ErrorWithCode(`Cannot unshift into an absolute path`, 'ABSOLUTE_PATH');
        }
        else {
            throw new Error(`Path is not normalized`);
        }
    }
    else {
        throw new ErrorWithCode(`Segment ${JSON.stringify(segment)} is invalid`, `INVALID_NAME`);
    }
}
export function PathSegmentsShift(path, options) {
    if (IsRootPathSegment(path[0], options.rootRegExp)) {
        path[0] = '.';
    }
    else {
        path.shift();
    }
}
export function ForcePathSegmentsAsAbsolute(path, rootSegment, options) {
    if (IsRootPathSegment(rootSegment, options.rootRegExp)) {
        const firstSegment = path[0];
        if (firstSegment === '.') {
            path[0] = rootSegment;
        }
        else if (firstSegment === '..') {
            while (path[0] === '..') {
                path.shift();
            }
            path.unshift(rootSegment);
        }
        else if (IsRootPathSegment(firstSegment, options.rootRegExp)) {
        }
        else {
            throw new Error(`Path is not normalized`);
        }
    }
    else {
        throw new ErrorWithCode(`Root is invalid`, `INVALID_ROOT`);
    }
}
export function ForcePathSegmentsAsRelative(path, options) {
    if (IsRootPathSegment(path[0], options.rootRegExp)) {
        path[0] = '.';
    }
}
//# sourceMappingURL=mutate.js.map